import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import JoditEditor from "jodit-react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { FileUploader } from "react-drag-drop-files";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Alert,
  CircularProgress,
  FormControl,
  FormLabel,
  IconButton,
  Switch,
  Typography,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../store/helpers/mapDispatch";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import ListTile from "./ListTile";
import MenuItem from "@mui/material/MenuItem";
import { Close, CloseRounded } from "@mui/icons-material";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { useEffect } from "react";
import { getError, getSuccessMessage } from "../store/helpers/common_functions";
import { successToast } from "./Notification";
import moment from "moment";
import QtMaterialButton from "../components/QtMaterialButton";
import { getDateList, monthList } from "./Common_functions";
import DatePicker from "react-multi-date-picker";
import secureLocalStorage from "react-secure-storage";
import FileUpload from "components/UI/FileUpload";
import { BsEye } from "react-icons/bs";

const cheerio = require("cheerio");
const fileTypes = [
  "PDF",
  "JPG",
  "JPEG",
  "PNG",
  "GIF",
  "DOCX",
  "DOC",
  "XLSX",
  "XLS",
];

export function CheckBoxItem({ item }) {
  return (
    <div className={"flex flex-wrap"}>
      {item.values?.map((v) => (
        <div
          className={`w-full lg:w-${item.checkCol ?? 6}/12 xl:w-${
            item.checkCol ?? 6
          }/12 px-2`}
        >
          <ListTile
            selected={item.value?.filter((i) => i === v.value)?.length > 0}
            handleToggle={(it) => {
              if (item.setValue && typeof item.setValue === "function") {
                if (item.value?.filter((i) => i === v.value)?.length > 0) {
                  item.setValue(item.value.filter((i) => i !== v.value));
                } else if (item.value?.length) {
                  item.value.push(v.value);
                  item.setValue([...item.value]);
                } else {
                  item.setValue([v.value]);
                }
              }
            }}
            item={{ label: v.label }}
          />
        </div>
      ))}
    </div>
  );
}

function FormDialog({
  open,
  formAlert,
  setOpen,
  title,
  fields,
  url,
  SubmitGeneralForm,
  onSuccess,
  col,
  maxWidth,
  useMaterial,
  buttonColor,
  buttonTitle,
  beforeSubmit,
  additionalContent,
  customSubmit,
  showAdditionalContent,
}) {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    control,
  } = useForm();
  const editor = React.useRef(null);
  const mPad = "-month-pad";
  const settings = secureLocalStorage.getItem("systemSettings");
  const settingsInfo = JSON.parse(settings);
  const mainBackground = settingsInfo?.mainBackground;
  const [files, setFiles] = React.useState();

  const config = React.useMemo(
    () => ({
      present: "document",
      editHTMLDocumentMode: false,
      spellCheck: true,
      iframe: true,
      uploader: {
        insertImageAsBase64URI: true,
      },
      direction: "ltr",
      enter: "BR",
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
    }),
    []
  );
  useEffect(() => {
    watch((value, { name, type }) => {
      if (type === "change") {
        fields.forEach((v) => {
          const padName = `${v.name}${mPad}`;
          if (
            (name === v.name || padName === name) &&
            v.setValue &&
            typeof v.setValue === "function"
          ) {
            if (v.type === "date-month") {
              v.setValue(`${value[padName]}-${value[name]}`);
            } else {
              v.setValue(value[name]);
            }
          }
        });
      }
    });
  }, [watch, fields]);

  useEffect(() => {
    fields.forEach((v) => {
      if (v.type === "date-month") {
        if (v.value) {
          setValue(`${v.name}${mPad}`, v.value.split("-")[0]);
          setValue(v.name, v.value.split("-")[1]);
        } else {
          setValue(`${v.name}${mPad}`, null);
          setValue(v.name, null);
        }
      } else {
        setValue(v.name, v.value);
      }
    });
  }, [fields]);

  useEffect(() => {
    fields.forEach((v) => {
      if (v.type === "group") {
        v.fields?.forEach((subField) => {
          if (subField.value !== undefined) {
            setValue(subField.name, subField.value); // Set initial value
          }
        });
      }
    });
  }, [fields, setValue]);

  const onSubmit = async (event) => {
    fields?.forEach((v) => {
      if (v.setValue && typeof v.setValue === "function") {
        if (event[v.name]) {
          if (v.type === "date-month") {
            const padName = `${v.name}${mPad}`;
            v.setValue(`${event[padName]}-${event[v.name]}`);
          } else {
            v.setValue(event[v.name]);
          }
        }
      }
    });

    let payload = event;
    if (typeof beforeSubmit === "function") {
      const result = beforeSubmit(event);
      if (!result) {
        return result;
      }
      payload = result;
    }

    setLoading(true);
    let formData;
    const nonFileData = { ...payload };

    fields?.forEach((v) => {
      if (v.type === "file" || v.type === "file-drag") {
        formData = formData ?? new FormData();
        if (v.value) {
          if (v.multiple) {
            Array.from(v.value).forEach((file) => {
              formData.append(v.name, file);
            });
          } else {
            formData.append(v.name, v.value);
          }
        }
      }
    });

    if (formData) {
      formData.append("body", JSON.stringify(nonFileData));
    }

    const submitPayload = formData ?? nonFileData;
    const resp = await SubmitGeneralForm(url, submitPayload, "POST");

    if (resp.status) {
      successToast(getSuccessMessage(resp));
      handleClose();
      if (onSuccess) onSuccess(resp);
    } else {
      setError(getError(resp));
    }
    setLoading(false);
  };
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState();
  const handleClose = () => {
    fields?.map((v) => {
      if (v.setValue && typeof v.setValue === "function") {
        v.setValue(null);
      }
    });
    clearErrors();
    setOpen(0);
    setError(null);
  };

  // Function to format number with commas
  const formatNumber = (num) => {
    const numStr = num?.toString();
    return numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Function to remove commas from number
  const unformatNumber = (num) => {
    num = num?.toString();
    return num?.replace(/,/g, "");
  };

  const disableWeekends = (weekDay) => {
    return weekDay === 0 || weekDay === 6;
  };

  const disablePastDates = (currentDate) => {
    const today = new Date();
    return currentDate.toDate() < today.setHours(0, 0, 0, 0);
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={maxWidth ?? "sm"}
        open={open}
        onClose={handleClose}
      >
        {loading ? (
          <div
            className={
              "absolute h-full w-full top-0 left-0 flex z-50 justify-center items-center"
            }
            style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
          >
            <div
              className={"bg-white p-3 rounded shadow text-center"}
              style={{ zIndex: 20000 }}
            >
              <div>
                <CircularProgress color={"success"} />
              </div>
              <span>
                <Typography>Submitting ....</Typography>
              </span>
            </div>
          </div>
        ) : null}
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>
            <div className={"flex items-center"}>
              <div className={"flex-grow font-bold text-lg"}>
                {title ?? "Form"}
              </div>
              <IconButton onClick={handleClose}>
                <img
                  src={require("assets/icons/close.svg").default}
                  alt={"close"}
                />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent className={"pt-2"}>
            {formAlert ? (
              <Alert
                style={{ width: "100%" }}
                className={"mb-3"}
                severity={"warning"}
              >
                {formAlert}
              </Alert>
            ) : null}

            {error ? (
              <Alert
                style={{ width: "100%" }}
                className={"mb-3"}
                severity={"error"}
                onClose={() => setError(null)}
              >
                {error}
              </Alert>
            ) : null}
            {/*<DialogContentText>*/}
            {/*</DialogContentText>*/}
            <div className={"flex flex-wrap"}>
              {fields?.map((v) => {
                if (v.hidden) {
                  return null;
                }

                let requiredRule = {
                  required: v.required ? `${v.label} is required !!!` : false,
                };

                if (
                  v.maxDate ||
                  v.minDate ||
                  typeof v.validate === "function"
                ) {
                  requiredRule = {
                    ...requiredRule,
                    validate: (val) => {
                      let resp = true;
                      if (v.maxDate) {
                        resp = moment(val).isSameOrBefore(v.maxDate)
                          ? true
                          : `Date can't be greater than ${v.maxDate.format(
                              "YYYY-MMM-DD"
                            )}`;
                      }

                      if (resp === true && v.minDate) {
                        resp = moment(val).isSameOrAfter(v.minDate)
                          ? true
                          : `Date can't be less than ${v.minDate.format(
                              "YYYY-MMM-DD"
                            )}`;
                      }

                      if (typeof v.validate === "function") {
                        return v.validate(val, v) ?? resp;
                      }

                      return resp;
                    },
                  };
                }

                // if(v.minDate){
                //     requiredRule = {
                //         ...requiredRule,
                //         validate:(val)=>
                //     }
                // }

                const validationProps = register(v.name, {
                  ...requiredRule,
                  max: v.hasOwnProperty("max")
                    ? {
                        value: v.max,
                        message: `Maximum number is ${v.max?.toLocaleString()}`,
                      }
                    : undefined,
                  min: v.hasOwnProperty("min")
                    ? {
                        value: v.min,
                        message: `Minimum number is ${v.min?.toLocaleString()}`,
                      }
                    : undefined,
                  minLength: v.hasOwnProperty("minLength")
                    ? {
                        value: v.minLength,
                        message: `Minimum length is ${v.minLength?.toLocaleString()}`,
                      }
                    : undefined,
                  maxLength: v.hasOwnProperty("maxLength")
                    ? {
                        value: v.maxLength,
                        message: `Maximum length is ${v.maxLength?.toLocaleString()}`,
                      }
                    : undefined,
                  pattern:
                    v.type === "tel"
                      ? {
                          value: /^(^\+?(?:[+0]9)?[0-9]{8,14}$)$/i,
                          message: "Invalid Phone number",
                        }
                      : v.type === "email"
                      ? {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        }
                      : null,
                });

                const type = v.type === "email" ? "text" : v.type ?? "text";

                const mPadName = `${v.name}${mPad}`;

                const hasError =
                  errors[v.name] ||
                  (v.type === "date-month" && errors[mPadName]);

                const className = `${
                  v.disabled ? "bg-gray-500 disabled:opacity-75" : ""
                } ${
                  hasError ? "border border-red-500" : "border-1 "
                } px-3 py-3 border-input placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150`;

                const label = (
                  <label
                    style={{ color: "#333333" }}
                    className={`block uppercase text-xs font-normal ${
                      v.type === "switch" ? "" : "mb-2"
                    }`}
                    htmlFor={v.id}
                  >
                    {v.label}
                    {v.required ? (
                      <span className={"text-red-500 font-bold ml-1"}>*</span>
                    ) : null}
                  </label>
                );

                if (typeof v.render === "function") {
                  return (
                    <div
                      className={`mb-3 mt-2 w-full lg:w-${
                        v.col ?? col ?? 12
                      }/12 xl:w-${v.col ?? col ?? 12}/12 px-2`}
                    >
                      {label}
                      {v.render()}
                    </div>
                  );
                }

                if (v.type === "group") {
                  return (
                    <div
                      key={v.name}
                      className="w-full px-2 mb-4"
                      style={
                        v.style || {
                          border: "1px solid #ccc",
                          padding: "10px",
                          borderRadius: "5px",
                        }
                      }
                    >
                      <Typography variant="subtitle1" gutterBottom>
                        {v.label}
                        {v.required && (
                          <span className="text-red-500 font-bold ml-1">*</span>
                        )}
                      </Typography>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {v.fields?.map((subField) => {
                          const nestedValidation = register(subField.name, {
                            required: subField.required
                              ? `${subField.label} is required!!!`
                              : false,
                            validate: subField.validate,
                          });

                          return (
                            <div key={subField.name} className="mb-3">
                              <Controller
                                name={subField.name}
                                control={control}
                                rules={{
                                  required: subField.required
                                    ? `${subField.label} is required!!!`
                                    : false,
                                  validate: subField.validate,
                                }}
                                render={({ field, fieldState: { error } }) => {
                                  const commonProps = {
                                    ...field,
                                    error: !!error,
                                    helperText: error?.message,
                                    fullWidth: true,
                                    size: "small",
                                    variant: "outlined",
                                    label: subField.label,
                                    required: subField.required,
                                  };

                                  switch (subField.type) {
                                    case "text":
                                      return (
                                        <TextField
                                          sx={{
                                            "& .MuiInputLabel-asterisk": {
                                              color: "#ef4444",
                                              fontWeight: "bold",
                                            },
                                          }}
                                          {...commonProps}
                                          value={field.value || ""}
                                          onChange={(e) => {
                                            field.onChange(e.target.value);
                                            if (subField.setValue) {
                                              subField.setValue(e.target.value);
                                            }
                                          }}
                                        />
                                      );

                                    case "select":
                                      return (
                                        <FormControl
                                          fullWidth
                                          size="small"
                                          error={!!error}
                                        >
                                          <InputLabel
                                            required={subField.required}
                                            sx={{
                                              "& .MuiInputLabel-asterisk": {
                                                color: "#ef4444",
                                                fontWeight: "bold",
                                              },
                                            }}
                                          >
                                            {subField.label}
                                          </InputLabel>
                                          <Select
                                            {...commonProps}
                                            value={field.value || ""}
                                            onChange={(e) => {
                                              field.onChange(e.target.value);
                                              if (subField.setValue) {
                                                subField.setValue(
                                                  e.target.value
                                                );
                                              }
                                            }}
                                          >
                                            {subField.values?.map((option) => (
                                              <MenuItem
                                                key={option.value}
                                                value={option.value}
                                              >
                                                {option.label}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                          {error && (
                                            <p className="text-red-500 text-xs mt-1">
                                              {error.message}
                                            </p>
                                          )}
                                        </FormControl>
                                      );
                                    case "tel":
                                      return (
                                        <TextField
                                          {...commonProps}
                                          type="tel"
                                          value={field.value || ""}
                                          onChange={(e) => {
                                            let val = e.target.value.replace(
                                              /[^0-9+ ]/g,
                                              ""
                                            );
                                            if (val.includes("+")) {
                                              val =
                                                "+" + val.replace(/\+/g, "");
                                            }
                                            field.onChange(val);
                                            if (subField.setValue) {
                                              subField.setValue(val);
                                            }
                                          }}
                                          inputProps={{
                                            pattern: "^[+0]?[0-9 ]{8,14}$",
                                            title:
                                              "Invalid Phone number. Only numbers and an optional leading + or 0 are allowed.",
                                            maxLength: 20,
                                          }}
                                        />
                                      );

                                    case "date":
                                      return (
                                        <TextField
                                          {...commonProps}
                                          type="date"
                                          InputLabelProps={{ shrink: true }}
                                          value={field.value || ""}
                                          onChange={(e) => {
                                            field.onChange(e.target.value);
                                            if (subField.setValue) {
                                              subField.setValue(e.target.value);
                                            }
                                          }}
                                        />
                                      );

                                    default:
                                      return null;
                                  }
                                }}
                              />
                              {errors[subField.name] && (
                                <p className="text-red-500 text-xs mt-1">
                                  {errors[subField.name].message}
                                </p>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                }

                if (v.type === "array") {
                  const arrayValues = watch(v.name) || [];
                  return (
                    <div key={v.name} className={`w-full px-2 mb-4`}>
                      <div className="flex items-center justify-between mb-2">
                        <Typography variant="subtitle1">
                          {v.label}
                          {v.required && (
                            <span className="text-red-500 font-bold ml-1">
                              *
                            </span>
                          )}
                        </Typography>
                        <Button
                          variant="outlined"
                          size="small"
                          sx={{ color: mainBackground }}
                          onClick={() => setValue(v.name, [...arrayValues, {}])}
                        >
                          Add {v.itemLabel || "Item"}
                        </Button>
                      </div>

                      {arrayValues.map((item, index) => (
                        <div key={index} className="mb-4 p-3 border rounded">
                          <div className="flex justify-between items-center mb-2">
                            <Typography variant="body2">
                              {v.itemLabel?.(index, arrayValues) ||
                                `Item ${index + 1}`}
                            </Typography>
                            <IconButton
                              size="small"
                              onClick={() => {
                                const newArray = arrayValues.filter(
                                  (_, i) => i !== index
                                );
                                setValue(v.name, newArray);
                              }}
                            >
                              <CloseRounded fontSize="small" />
                            </IconButton>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {v.fields?.map((subField) => {
                              const nestedName = `${v.name}.${index}.${subField.name}`;
                              const nestedField = {
                                ...subField,
                                name: nestedName,
                                value: watch(nestedName),
                                setValue: (val) => {
                                  setValue(nestedName, val);
                                  if (
                                    subField.setValue &&
                                    typeof subField.setValue === "function"
                                  ) {
                                    subField.setValue(val, index);
                                  }
                                },
                              };

                              if (
                                nestedField.showIf &&
                                !nestedField.showIf(watch(), index)
                              ) {
                                return null;
                              }

                              return (
                                <div key={nestedName} className="mb-3">
                                  <Controller
                                    name={nestedName}
                                    control={control}
                                    rules={{
                                      required: subField.required
                                        ? `${subField.label} is required!!!`
                                        : false,
                                      validate: subField.validate,
                                      min: subField.min,
                                      max: subField.max,
                                      pattern: subField.pattern,
                                    }}
                                    render={({
                                      field,
                                      fieldState: { error },
                                    }) => {
                                      const commonProps = {
                                        ...field,
                                        error: !!error,
                                        helperText: error?.message,
                                        fullWidth: true,
                                        size: "small",
                                        variant: "outlined",
                                        label: subField.label,
                                        required: subField.required,
                                      };

                                      switch (subField.type) {
                                        case "text":
                                          return (
                                            <TextField
                                              sx={{
                                                "& .MuiInputLabel-asterisk": {
                                                  color: "#ef4444",
                                                  fontWeight: "bold",
                                                },
                                              }}
                                              {...commonProps}
                                              value={field.value || ""}
                                              onChange={(e) => {
                                                field.onChange(e.target.value);
                                                nestedField.setValue(
                                                  e.target.value
                                                );
                                              }}
                                            />
                                          );

                                        case "select":
                                          const options =
                                            typeof subField.values ===
                                            "function"
                                              ? subField.values(index)
                                              : subField.values || [];

                                          return (
                                            <FormControl
                                              fullWidth
                                              size="small"
                                              error={!!error}
                                            >
                                              <InputLabel>
                                                {subField.label}
                                                {subField.required && (
                                                  <span className="text-red-500 font-bold ml-1">
                                                    *
                                                  </span>
                                                )}
                                              </InputLabel>
                                              <Select
                                                {...commonProps}
                                                value={field.value || ""}
                                                onChange={(e) => {
                                                  field.onChange(
                                                    e.target.value
                                                  );
                                                  nestedField.setValue(
                                                    e.target.value
                                                  );
                                                }}
                                              >
                                                {options.map((option) => (
                                                  <MenuItem
                                                    key={option.value}
                                                    value={option.value}
                                                  >
                                                    {option.label}
                                                  </MenuItem>
                                                ))}
                                              </Select>
                                              {error && (
                                                <p className="text-red-500 text-xs mt-1">
                                                  {error.message}
                                                </p>
                                              )}
                                            </FormControl>
                                          );

                                        case "date":
                                          return (
                                            <TextField
                                              {...commonProps}
                                              type="date"
                                              InputLabelProps={{ shrink: true }}
                                              value={field.value || ""}
                                              onChange={(e) => {
                                                field.onChange(e.target.value);
                                                nestedField.setValue(
                                                  e.target.value
                                                );
                                              }}
                                            />
                                          );

                                        case "number":
                                          return (
                                            <TextField
                                              {...commonProps}
                                              type="number"
                                              value={field.value || ""}
                                              onChange={(e) => {
                                                const unformattedValue =
                                                  unformatNumber(
                                                    e.target.value
                                                  );
                                                if (!isNaN(unformattedValue)) {
                                                  field.onChange(
                                                    unformattedValue
                                                  );
                                                  nestedField.setValue(
                                                    unformattedValue
                                                  );
                                                }
                                              }}
                                              inputProps={{
                                                step: "any",
                                                min: subField.min,
                                                max: subField.max,
                                              }}
                                            />
                                          );
                                        case "tel":
                                          return (
                                            <TextField
                                              {...commonProps}
                                              type="tel"
                                              value={field.value || ""}
                                              onChange={(e) => {
                                                let val =
                                                  e.target.value.replace(
                                                    /[^0-9+ ]/g,
                                                    ""
                                                  );
                                                if (val.includes("+")) {
                                                  val =
                                                    "+" +
                                                    val.replace(/\+/g, "");
                                                }
                                                field.onChange(val);
                                                nestedField.setValue(val);
                                              }}
                                              inputProps={{
                                                pattern: "^[+0]?[0-9 ]{8,14}$",
                                                title:
                                                  "Invalid Phone number. Only numbers and an optional leading + or 0 are allowed.",
                                                maxLength: 20,
                                              }}
                                            />
                                          );
                                        case "email":
                                          return (
                                            <TextField
                                              {...commonProps}
                                              type="email"
                                              value={field.value || ""}
                                              onChange={(e) => {
                                                field.onChange(e.target.value);
                                                nestedField.setValue(
                                                  e.target.value
                                                );
                                              }}
                                            />
                                          );

                                        default:
                                          return null;
                                      }
                                    }}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                }

                if (v.type === "radio") {
                  return (
                    <div key={v.name} className="w-full px-2 mb-4">
                      {/* <FormControl component="fieldset"> */}
                      <FormControl
                        component="fieldset"
                        error={!!errors[v.name]}
                      >
                        <FormLabel
                          component="legend"
                          sx={{
                            color: "inherit",
                            "&.Mui-focused": {
                              color: mainBackground,
                            },
                          }}
                        >
                          {v.label}
                          {v.required && (
                            <span className="text-red-500 font-bold ml-1">
                              *
                            </span>
                          )}
                        </FormLabel>
                        <Controller
                          name={v.name}
                          control={control}
                          render={({ field }) => (
                            <RadioGroup
                              {...field}
                              onChange={(e) => {
                                field.onChange(e.target.value);
                                v.setValue(e.target.value);
                              }}
                            >
                              <div className="flex gap-4">
                                {v.values.map((option) => (
                                  <FormControlLabel
                                    key={option.value}
                                    value={option.value}
                                    control={
                                      <Radio
                                        sx={{
                                          color:
                                            field.value === option.value
                                              ? mainBackground
                                              : "default",
                                          "&.Mui-checked": {
                                            color: mainBackground,
                                          },
                                        }}
                                      />
                                    }
                                    label={option.label}
                                  />
                                ))}
                              </div>
                            </RadioGroup>
                          )}
                        />
                        {errors[v.name] && (
                          <p className="text-red-500 text-xs mt-1">
                            {v.label} is required
                          </p>
                        )}
                      </FormControl>
                    </div>
                  );
                }
                return (
                  <div
                    className={`mb-3 mt-2 w-full lg:w-${
                      v.col ?? col ?? 12
                    }/12 xl:w-${v.col ?? col ?? 12}/12 px-2`}
                  >
                    {v.type === "switch" ? (
                      <div className={"flex items-center"}>
                        {label}
                        <Controller
                          control={control}
                          rules={{
                            ...requiredRule,
                          }}
                          name={v.name}
                          render={({ field, fieldState: { error } }) => {
                            return (
                              <Switch
                                className={
                                  error?.message ? "border-red-500" : undefined
                                }
                                value={field.value ?? ""}
                                name={v.name}
                                checked={field.value === "1"}
                                onChange={(event, checked) => {
                                  if (
                                    v.setValue &&
                                    typeof v.setValue === "function"
                                  ) {
                                    setValue(v.name, `${checked ? 1 : 0}`);
                                    field.onChange(`${checked ? 1 : 0}`);
                                  }
                                }}
                              />
                            );
                          }}
                        />
                      </div>
                    ) : v.type === "number" && v.isNumber === true ? (
                      <div>
                        {label}
                        <Controller
                          control={control}
                          rules={{
                            ...requiredRule,
                            validate: v.required
                              ? (val) => val && !isNaN(unformatNumber(val))
                              : undefined,
                          }}
                          name={v.name}
                          render={({ field, fieldState: { error } }) => {
                            return (
                              <input
                                type="text"
                                value={formatNumber(field.value ?? "")}
                                onChange={(e) => {
                                  const unformattedValue = unformatNumber(
                                    e.target.value
                                  );
                                  if (!isNaN(unformattedValue)) {
                                    setValue(v.name, unformattedValue);
                                    field.onChange(unformattedValue);
                                  }
                                }}
                                className={
                                  error?.message ? "border-red-500" : className
                                }
                                placeholder={v.placeholder ?? v.label}
                              />
                            );
                          }}
                        />
                      </div>
                    ) : v.type === "editor" ? (
                      <div>
                        {label}
                        <Controller
                          control={control}
                          rules={{
                            ...requiredRule,
                            validate: v.required
                              ? (v) => {
                                  if (!v) {
                                    return requiredRule.required;
                                  }
                                  const $ = cheerio.load(v);
                                  return $.text()?.trim()?.length
                                    ? true
                                    : requiredRule.required;
                                }
                              : undefined,
                          }}
                          name={v.name}
                          render={({ field, fieldState: { error } }) => {
                            return (
                              <JoditEditor
                                config={config}
                                ref={editor}
                                className={
                                  error?.message ? "border-red-500" : undefined
                                }
                                value={field.value ?? ""}
                                onBlur={(newContent) => {
                                  if (
                                    v.setValue &&
                                    typeof v.setValue === "function"
                                  ) {
                                    // field.onChange(newContent);
                                    setValue(v.name, newContent);
                                  }
                                }}
                              />
                            );
                          }}
                        />
                      </div>
                    ) : v.type === "file-drag" ? (
                      <div>
                        {label}
                        <FileUploader
                          multiple={v.multiple ?? false}
                          classes={`${
                            errors[v.name] ? "border-red-500" : ""
                          } w-full flex-grow-1 max-width-full-i  min-width-full`}
                          style={{ maxWidth: "auto !important" }}
                          id={v.id}
                          handleChange={(e) => {
                            if (
                              v.setValue &&
                              typeof v.setValue === "function"
                            ) {
                              v.setValue(e);
                            }
                          }}
                          name="file"
                          types={fileTypes}
                          {...register(v.name, requiredRule)}
                        />
                        <FileUpload files={v?.value} />
                      </div>
                    ) : v.type === "checkbox" ? (
                      <div>
                        {label}
                        <CheckBoxItem item={v} />
                      </div>
                    ) : v.type === "radio" ? (
                      <div>
                        {label}
                        <div className={"flex flex-wrap"}>
                          {v.values?.map((item) => (
                            <div
                              className={`w-full lg:w-${
                                v.checkCol ?? 6
                              }/12 xl:w-${v.checkCol ?? 6}/12 px-2`}
                            >
                              <ListTile
                                selected={v.value === item.value}
                                handleToggle={(it) => {
                                  if (
                                    v.setValue &&
                                    typeof v.setValue === "function"
                                  ) {
                                    v.setValue(item.value);
                                  }
                                }}
                                item={{ label: item.label }}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : v.type === "select" ? (
                      useMaterial ? (
                        <FormControl fullWidth size={"small"}>
                          <InputLabel id="demo-simple-select-label">
                            {v.label}
                          </InputLabel>
                          <Select
                            native={true}
                            disabled={v.disabled ?? false}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            // value={v.value}
                            label={v.label}
                            {...register(v.name, requiredRule)}
                          >
                            <option value=""></option>
                            {v.values?.map((item) => (
                              <option value={item.value}>{item.label}</option>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <div className="relative w-full">
                          {label}
                          <select
                            placeholder={v.placeholder ?? v.label}
                            className={className}
                            disabled={v.disabled ?? false}
                            {...validationProps}
                          >
                            <option value="">-- select --</option>
                            {v.values?.map((item) => (
                              <option value={item.value}>{item.label}</option>
                            ))}
                          </select>
                        </div>
                      )
                    ) : useMaterial ? (
                      <TextField
                        autoFocus
                        id={v.id}
                        name={v.name}
                        disabled={v.disabled ?? false}
                        label={v.label}
                        minRows={v.type === "textarea" ? 5 : null}
                        type={type}
                        fullWidth
                        InputLabelProps={
                          v.type === "date" ||
                          v.type === "file" ||
                          v.type === "datetime-local"
                            ? {
                                shrink: true,
                              }
                            : {}
                        }
                        size={"small"}
                        variant="outlined"
                        {...validationProps}
                      />
                    ) : (
                      <div className="relative w-full">
                        {label}
                        {v.type === "textarea" ? (
                          <textarea
                            rows={v.rows ?? 3}
                            placeholder={v.placeholder ?? v.label}
                            disabled={v.disabled ?? false}
                            className={className}
                            {...validationProps}
                          ></textarea>
                        ) : v.type === "date-month" ? (
                          <div className={"flex w-full"}>
                            <div className={"flex-grow"}>
                              <select
                                className={className}
                                {...register(mPadName, {
                                  ...requiredRule,
                                })}
                              >
                                <option value="">-- sel --</option>
                                {getDateList().map((v) => (
                                  <option value={v.toString().padStart(2, "0")}>
                                    {v.toString().padStart(2, "0")}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className={"flex-grow"}>
                              <select
                                className={className}
                                {...validationProps}
                              >
                                <option value="">-- sel --</option>
                                {monthList.map((v) => (
                                  <option
                                    value={v.value.toString().padStart(2, "0")}
                                  >
                                    {v.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        ) : v.type === "date" &&
                          (v.weekendDisabled === true ||
                            v.holidaysDisabled === true) ? (
                          <DatePicker
                            disabled={v.disabled ?? false}
                            value={v.value}
                            className={`${className} p-4 p-[100px]`}
                            style={{
                              padding: "15px",
                            }}
                            minDate={v.minDate?.format("YYYY-MM-DD")}
                            maxDate={v.maxDate?.format("YYYY-MM-DD")}
                            onChange={(value) => {
                              if (
                                v.setValue &&
                                typeof v.setValue === "function"
                              ) {
                                if (moment(value).isValid()) {
                                  v.setValue(value.format("YYYY-MM-DD"));
                                }
                              }
                            }}
                            placeholder="Select a date"
                            mapDays={v.mapDays}
                          />
                        ) : (
                          <input
                            type={type}
                            placeholder={v.placeholder ?? v.label}
                            className={className}
                            min={v.minDate?.format("YYYY-MM-DD")}
                            max={v.maxDate?.format("YYYY-MM-DD")}
                            disabled={v.disabled ?? false}
                            {...validationProps}
                          />
                        )}
                      </div>
                    )}

                    {hasError && (
                      <p role="alert" className={"text-red-500 text-xs"}>
                        {errors[v.name]?.message ?? errors[mPadName]?.message}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
            {additionalContent ? (
              showAdditionalContent ? (
                <div className={"mt-3"}>
                  {typeof additionalContent === "function"
                    ? additionalContent()
                    : additionalContent}
                </div>
              ) : null
            ) : null}
          </DialogContent>
          <DialogActions className="mx-4">
            {customSubmit ? (
              <QtMaterialButton
                onClick={customSubmit}
                variant={"contained"}
                color={buttonColor ?? "primary"}
                type={"button"}
              >
                {buttonTitle ?? "Submit"}
              </QtMaterialButton>
            ) : (
              <QtMaterialButton
                color={buttonColor ?? "primary"}
                variant={"contained"}
                type={"submit"}
              >
                {buttonTitle ?? "Submit"}
              </QtMaterialButton>
            )}
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default connect(null, mapDispatchToProps)(FormDialog);
